import React, { Component } from 'react';

const ViewFinder = ()=> {

    return (
    	<div>
    		<svg width="100%" height="269px">
           <rect x="0" y="0" width="100%" height="100%" fill="black" />
            <circle cx="50%" cy="50%" r="6" fill="white" />
            <line x1="46%" y1="50%" x2="54%" y2="50%" stroke="blue" stroke-width="2" />
            <line x1="50%" y1="46%" x2="50%" y2="54%" stroke="blue" stroke-width="2" />
        </svg>
    	</div>	
    );
}

export default ViewFinder;